import { useCurrentPath } from 'app/hooks/use-current-path'
import { useStores } from 'app/store'
import { Button } from 'app/components/primitive/Button'
import { SizableText, Stack } from '@mythical/ui'
import { IconLock } from 'app/components/primitive/Icon'
import { observer } from 'mobx-react-lite'

export const CollectiblesUpgradePrompt = observer(
  ({ canMemberfulLink }: { canMemberfulLink: boolean }) => {
    const { upgradeModalState } = useStores()
    const { path: currentPath } = useCurrentPath()

    const handleUpgrade = () => {
      upgradeModalState.setUpgradeReturnPath(currentPath || '/')
      upgradeModalState.openUpsellModal()
    }

    return (
      <Stack
        w="100%"
        br="$6"
        px="$4"
        py="$6"
        gap="$3"
        jc="center"
        ai="center"
        bg="$bgTertiary"
      >
        <SizableText ta="center" fontFamily="$display" size="$m" tt="uppercase">
          Upgrade to Access Collectibles
        </SizableText>

        <SizableText ta="center" size="$m" mx="auto" fow="500" maw={500}>
          Join All Access to unlock exclusive quarterly collectibles! Members
          receive unique items throughout the year.
        </SizableText>
        {canMemberfulLink && (
          <Button
            icon={<IconLock />}
            scaleSpace={0.4}
            scaleIcon={1.2}
            onPress={handleUpgrade}
          >
            Upgrade to All Access
          </Button>
        )}
      </Stack>
    )
  },
)
